// extracted by mini-css-extract-plugin
export default {"btnCustom":"Button_btnCustom__YLMIE","solid":"Button_solid__B36p2","outline":"Button_outline__aK8s1","btn":"Button_btn__QYRld","icon":"Button_icon__hL142"};